/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const OutputViewerAutoExpandFailedStepsSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('OUTPUT_VIEWER_AUTO_EXPAND_FAILED_STEPS'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class OutputViewerAutoExpandFailedStepsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return OutputViewerAutoExpandFailedStepsSettingParser.decode(input).map(res => new OutputViewerAutoExpandFailedStepsSetting(res));
    }
    static unsafeDecode(input) {
        return OutputViewerAutoExpandFailedStepsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return OutputViewerAutoExpandFailedStepsSettingParser.encode(data);
    }
    static schema() {
        return OutputViewerAutoExpandFailedStepsSettingParser.schema();
    }
}
